<template>
  <el-col>
    <el-table
      v-loading="ranks == null"
      @selection-change="handleSelectionChange"
      @row-click="editRank"
      :height="windowHeight - 238"
      :data="ranks">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column
        label="Name"
        sortable
        prop="name"
        min-width="150">
      </el-table-column>
      <el-table-column
        label="Weight"
        sortable
        prop="weight"
        align="center"
        min-width="120">
      </el-table-column>
    </el-table>
    <div class="clearfix">
      <el-row type="flex" style="margin: 8px; justify-content: flex-end;" class="bottom">
            <el-button v-if="multipleSelection.length != 0" @click="showDeleteDialog" icon="el-icon-delete" type="danger" size="small"></el-button>
            <el-button @click="newRank" type="primary" size="small" icon="el-icon-plus"></el-button>
      </el-row>
    </div>

    <el-dialog title="Manage Rank" :visible.sync="dialogRankVisible" :fullscreen="$mq === 'xs'">
      <el-form :label-position="labelPosition" :model="newp">
        <el-form-item label="Name" :label-width="formLabelWidth">
          <el-input v-model="newp.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="Weight" :label-width="formLabelWidth">
          <el-input-number v-model="newp.weight" :min="0"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogRankVisible = false">Cancel</el-button>
        <el-button type="primary" @click="saveRank(newp)">Save</el-button>
      </span>
    </el-dialog>
    <el-dialog
             title="Confirm Rank Deletion"
             :visible.sync="deleteDialogVisible"
             width="35%"
             :fullscreen="$mq === 'xs'"
             center>
      <span>Are you sure you want to delete these ranks?</span>
      <div style="max-height: 200px; overflow: auto;">
        <ul style="text-align: center; padding: 0; list-style: none;">
          <li v-for="rank in multipleSelection" v-bind:key="rank.o_id">{{rank.name}}</li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">No</el-button>
        <el-button type="danger" @click="deleteRanks">Confirm</el-button>
      </span>
    </el-dialog>
  </el-col>
</template>

<script>
import {mapFields} from 'vuex-map-fields';

export default {
    data() {
        return {
            delRank: null,
            newp: [],
            deleteLoading: false,
            multipleSelection: [],
            permissions: null,
            formLabelWidth: '140px',
            dialogRankVisible: false,
            deleteDialogVisible: false
        };
    },
    computed: {
        ...mapFields([
            'user',
            'ranks'
        ]),
        labelPosition() {
            return this.$mq == 'xs' ? 'top' : 'left';
        }
    },
    mounted() {
        if(this.ranks == null)
            this.$store.dispatch('pullRanks');
    },
    methods: {
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        newRank(){
            this.newp = {
                'o_id': null,
                'name': null,
                'weight': 0
            };
            this.dialogRankVisible = true;
        },
        showDeleteDialog(){
            this.deleteDialogVisible = true;
        },
        saveRank(row){
            var route = '';
            var bod;
            if(row.o_id != null){
                route = '/api/v1/ranks/'+ row.o_id;
                bod = {
                    name: row.name,
                    weight: row.weight
                };
                this.axios.put(
                    route, 
                    JSON.stringify(bod),
                    {
                        headers: {'Content-Type': 'application/json'},
                        credentials: 'same-origin'
                    }).then((response) => {
                    var temp = this.ranks.find((objv) => objv.o_id == response.data.o_id);
                    var index = this.ranks.indexOf(temp);
                    this.ranks.splice(index, 1, response.data);

                    this.$message({
                        showClose: true,
                        message: 'Rank saved successfuly.',
                        type: 'success'
                    });
                }).catch((err) => {
                    console.error(err);
                    this.$message({
                        showClose: true,
                        message: err.response.data.errors.title,
                        type: 'error'
                    });
                    this.restoreUnit(row.o_id);
                });
            }else{
                route = '/api/v1/ranks';
                bod = {
                    name: row.name,
                    weight: row.weight
                };
                this.axios.post(
                    route, 
                    JSON.stringify(bod),
                    {
                        headers: {'Content-Type': 'application/json'},
                        credentials: 'same-origin'
                    }).then((response) => {
                    this.ranks.push(response.data);
                    this.$message({
                        showClose: true,
                        message: 'Rank created successfuly',
                        type: 'success'
                    });
                }).catch((err) => {
                    console.error(err);
                    this.$message({
                        showClose: true,
                        message: err.response.data.errors.title,
                        type: 'error'
                    });
                });
            }
            this.dialogRankVisible = false;
        },
        deleteRanks() {
            this.deleteLoading = true;
            this.multipleSelection.forEach((row) => {
                this.axios.delete('/api/v1/ranks/'+row.o_id, {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then(() => {
                    this.$message({
                        showClose: true,
                        message: 'Rank deleted successfuly',
                        type: 'success'
                    });
                    var temp = this.ranks.find((objv) => objv.o_id == row.o_id);
                    var index = this.ranks.indexOf(temp);
                    this.ranks.splice(index, 1);
                }).catch((err) => {
                    console.error(err);
                    this.$message({
                        showClose: true,
                        message: 'Unable to delete rank.',
                        type: 'error'
                    });
                });
            });
            this.deleteDialogVisible = false;
        },
        editRank(row){
            this.newp ={
                'o_id': row.o_id,
                'name': row.name,
                'weight': row.weight
            };
            this.dialogRankVisible = true;
        }
    }
}
</script>
